import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MessageCenterComponent } from './message-center.component';

@NgModule({
  declarations: [
    MessageCenterComponent
  ],
  imports: [
    RouterModule
  ],
  providers: [],
  bootstrap: [MessageCenterComponent]
})
export class MessageCenterModule { }
